import { createContext, useContext, type ComponentType, type ReactNode } from 'react';

export interface DiffLabels {
  added: string;
  removed: string;
  formattingChanged: string;
}

/**
 * The concrete renderer (MarkdownSectionPreview) lives in features/editor, so
 * other features reach it through this context instead of a cross-feature
 * import (import/no-restricted-paths). It is mounted at app/router.tsx,
 * mirroring document-editor-context.tsx.
 */
export type MarkdownPreviewRenderer = ComponentType<{
  markdown: string;
  baseline?: string;
  className?: string;
  labels?: DiffLabels;
}>;

const MarkdownPreviewContext = createContext<MarkdownPreviewRenderer | null>(null);

interface MarkdownPreviewProviderProps {
  renderer: MarkdownPreviewRenderer;
  children: ReactNode;
}

export function MarkdownPreviewProvider({ renderer, children }: MarkdownPreviewProviderProps) {
  return (
    <MarkdownPreviewContext.Provider value={renderer}>
      {children}
    </MarkdownPreviewContext.Provider>
  );
}

export function useMarkdownPreview(): MarkdownPreviewRenderer | null {
  return useContext(MarkdownPreviewContext);
}
